import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import UseTranslation from '../../../../hooks/UseTranslation'
import FormModalContainer from '../../../../components/Modals/FormModalContainer'
import ActiveFiltersWithKey from '../../../../components/PageHelpers/ActiveFiltersWithKey'
import SortBy from '../../../../components/PageHelpers/Sort'
import OfoqDateRingePicker from '../../../../components/Forms/OfoqDateRingePicker'
import GenericBtn from '../../../../components/Buttons/OfoqThemeBtn'
import { selectNotification } from '../../../../redux/features/notifications/notificationCenter/notificationCenterSlice'
import {
  getNotificationsListWithQueries,
  filterNotificationsCenterList,
} from '../../../../redux/features/notifications/notificationCenter/notificationCenterThunk'
import OfoqMultiAutoComplete from '../../../../components/Forms/OfoqMultiAutoComplete'

const Mobile = ({
  openModal, setOpenModal, headers, setHeaders, date, setDate,
}) => {
  const { t } = UseTranslation()
  const notificationStore = useSelector(selectNotification)
  const dispatch = useDispatch()
  const handleClose = () => {
    setOpenModal(false)
  }
  const clearAllFilters = () => {
    dispatch(filterNotificationsCenterList({ queries: 'clear' }))
  }
  const isFilteredArraysNotEmpty = Object.values(notificationStore?.activeFilters).some(
    (singleFilter) => singleFilter?.length,
  )
  return (
    <FormModalContainer
      modalTitle={`${t?.['Filter By']}`}
      modalState={openModal}
      handleClose={handleClose}
      formModalStyle
      cancelText={t?.Close}
    >
      <Box sx={styles.filterBox}>
        {isFilteredArraysNotEmpty && (
        <ActiveFiltersWithKey
          title={t?.['Applied Filters']}
          store={notificationStore}
          actionToDispatch={filterNotificationsCenterList}
          customStyles={styles.activeFilter}
        />
        )}
        <SortBy
          store={notificationStore}
          actionToDispatch={getNotificationsListWithQueries}
          customStyles={styles.sortBy}
          sendQueryAsObject
          actionProps={{ pageNumber: 0 }}
        />
        <OfoqDateRingePicker
          name={t?.Date}
          customPlaceHolder={t?.['Select Date/period']}
          refState={setDate}
          defaultOption={date}
        />
        <OfoqMultiAutoComplete
          name={t?.Header}
          store={notificationStore?.filterList?.headers}
          defaultOption={headers}
          refState={setHeaders}
          customStyle={styles.firstFilter}
          multiple
        />
      </Box>
      <GenericBtn
        name={`${t?.['Clear Filters']}`}
        disabled={!isFilteredArraysNotEmpty}
        onClick={clearAllFilters}
        customStyle={styles.clearFilters}
      />
    </FormModalContainer>
  )
}

const styles = {
  firstFilter: {
    marginRight: '30px',
  },
  activeFilter: {
    flexWrap: 'wrap',
  },
  clearFilters: {
    maxWidth: { xs: '100%', sm: '0px' },
    minWidth: { xs: '80px', sm: '0px' },
    marginTop: { xs: '20px', sm: 'unset' },
    mx: { xs: '0px !important', sm: 'unset' },
  },
  filterBox: {
    display: 'flex',
    gap: { xs: '10px', md: '23px' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
  },
  sortBy: {
    margin: { xs: '15px 0px', sm: '0 15px' },
  },
}
export default Mobile
